"use client";

import { init as initFullStory } from "@fullstory/browser";
import { useEffect } from "react";

export function FullStoryProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    initFullStory({ orgId: "o-2343KE-na1" });
  }, []);

  return <>{children}</>;
}
